import { createApiConstants } from '@saucelabs/sl-util-redux';

export const createTestOverviewTypes = (namespace) => {
  const createApiNamespacedConstants = createApiConstants.bind(null, namespace);

  return {
    SELECT_BY_VERSION: `${namespace}/SELECT_BY_VERSION`,
    CLEAR_SELECT_BY_VERSION: `${namespace}/CLEAR_SELECT_BY_VERSION`,
    CLEANUP_TEST_SUMMARY: `${namespace}/CLEANUP_TEST_SUMMARY`,
    CHANGE_PAGE: `${namespace}/CHANGE_PAGE`,
    GET_TEST_TRENDS: createApiNamespacedConstants('GET_TEST_TRENDS'),
    GET_PAST_TRENDS: createApiNamespacedConstants('GET_PAST_TRENDS'),
    GET_TEST_HEALTH: createApiNamespacedConstants('GET_TEST_HEALTH'),
    GET_PAST_HEALTH: createApiNamespacedConstants('GET_PAST_HEALTH'),
    GET_AGGREGATED_TEST_ERRORS: createApiNamespacedConstants('GET_AGGREGATED_TEST_ERRORS'),
    GET_TESTS_BY_ERROR: createApiNamespacedConstants('GET_TESTS_BY_ERROR'),
  };
};
